// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__k6xp5","header":"Messages_header__mAfdM"};